'use client'
import { type UserUserKYC, type AgentUserKYC } from '@repo/services'
import { ButtonLink } from '../../components'
import { useTranslate } from '../../hooks'
import {
  Alert,
  Button,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  onCloseModal,
} from '@repo/ui/components'

interface KycBlockerProps {
  phone?: string
  email?: string
  kyc?: UserUserKYC | AgentUserKYC
}

export const KycBlocker = (props: KycBlockerProps) => {
  const { phone, email, kyc } = props
  const { t } = useTranslate()

  const kycStatusText = {
    waiting_for_review: t('common_kyc_waiting_for_review'),
    under_review: t('common_kyc_under_review'),
    rejected: t('common_kyc_rejected', {
      reason: kyc?.comment || '',
    }),
  }

  return (
    <>
      <ModalHeader>
        <ModalTitle>{t('common_kycBlocker_title')}</ModalTitle>
      </ModalHeader>

      <Alert
        color='negative'
        hideIcon
        size='md'
        caption={
          !kyc?.status
            ? t('common_kycBlocker_description')
            : kycStatusText[kyc?.status as keyof typeof kycStatusText]
        }
        className='mt-xl'
      />

      <ModalFooter className='flex flex-col gap-md'>
        {(!kyc?.status || kyc?.status === 'rejected') && (
          <ButtonLink
            href={
              phone
                ? `/auth/quick-kyc?mobileOrEmail=${phone}`
                : `/auth/kyc?mobileOrEmail=${email}`
            }
            color='base'
            width='full'
            variant='ghost'
            size='md'
            className='mt-xl'
          >
            {t('common_kycBlocker_button')}
          </ButtonLink>
        )}
        <Button
          variant='transparent'
          color='neutral'
          size='md'
          width='full'
          onClick={onCloseModal}
        >
          {t('common_kycBlocker_button_cancel')}
        </Button>
      </ModalFooter>
    </>
  )
}
